import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Input, Button, List, Typography, Spin, message } from "antd";
import { useVoiceToText } from "react-speakup"; // Import the hook
import { AI_API_CHAT_URL } from "../../utils/contrains";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faUser,
  faComments,
  faStop,
  faCaretSquareUp,
} from "@fortawesome/free-solid-svg-icons";
const { Title } = Typography;

const CreateCounseling = (props) => {
  const [messages, setMessages] = useState([
    { role: "system", content: "你好！有什麼我可以協助的呢?" },
  ]);
  const [isListening, setIsListening] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [assistantTyping, setAssistantTyping] = useState("");
  const [loading, setLoading] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null); // 儲存計時器 ID

  // Voice to text hook
  const { startListening, stopListening, transcript, reset } = useVoiceToText({
    continuous: true,
    lang: "zh-TW", // Set language to Traditional Chinese
  });

  // Effect to update user input with transcript
  useEffect(() => {
    if (transcript) {
      setUserInput(transcript);
    }
  }, [transcript]);

  const sendMessage = async (input) => {
    const url = AI_API_CHAT_URL;
    const data = {
      model: "gemma2",
      messages: [
        ...messages,
        {
          role: "user",
          content:
            "您扮演一位台灣台南應用科技大學的專業心理諮商師，回答時請以繁體中文描述，且語氣以關懷的態度回答，若提問出現內容有關於生死議題，請提供本校諮詢專線：06-2531980，或提供諮商輔導中心網址：'https://stud.tut.edu.tw/p/406-1007-30948,r1378.php?Lang=zh-tw'，若非心理諮商相關問題，直接回答'您所提問問題非心理相關，我無法幫您解答'。以下為所提問的問題內容:/n" +
            input,
        },
      ],
      stream: false,
    };

    setLoading(true);

    try {
      const response = await axios.post(url, data);
      if (response.status === 200) {
        const content = response.data.message.content;
        typingEffect(content);
      } else {
        console.error(`Error: ${response.status}, ${response.data}`);
      }
    } catch (error) {
      console.error(
        `Error: ${error.response ? error.response.status : "Network Error"}, ${
          error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  // Function to simulate typing effect
  const typingEffect = (content) => {
    setAssistantTyping("");
    let index = 0;
    const timer = setInterval(() => {
      if (index < content.length) {
        setAssistantTyping((prev) => prev + content[index]);
        index++;
      } else {
        clearInterval(timer);
        setTypingTimer(null); // 清除計時器 ID
        setMessages((prevMessages) => [
          ...prevMessages,
          { role: "system", content },
        ]);
        setAssistantTyping("");
      }
    }, 100);
    setTypingTimer(timer); // 保存計時器 ID
  };

  const handleToggleListening = () => {
    if (isListening) {
      stopListening();
    } else {
      startListening();
    }
    setIsListening(!isListening);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedInput = userInput.trim();
    if (!userInput.trim()) {
      message.error("輸入欄位不能為空白！");
      return;
    }
    if (assistantTyping) {
      message.error("請等待目前的輸出完成！");
      return;
    }
    if (
      trimmedInput.toLowerCase() === "exit" ||
      trimmedInput.toLowerCase() === "quit"
    ) {
      console.log("再見！");
      return;
    }

    setMessages((prevMessages) => [
      ...prevMessages,
      { role: "user", content: trimmedInput },
    ]);

    // Clear user input and transcript after submission
    setUserInput("");

    sendMessage(trimmedInput);
    // Stop listening after submission
    setIsListening(false);
    stopListening();
    reset();
  };

  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };

    // 中斷輸出的按鈕功能
    const handleInterruptTyping = () => {
      if (typingTimer) {
        clearInterval(typingTimer); // 停止計時器
        setTypingTimer(null); // 清除計時器 ID
        setMessages((prevMessages) => [
          ...prevMessages,
          { role: "system", content: assistantTyping },
        ]); // 將目前的輸出加入歷史訊息
        setAssistantTyping(""); // 清空輸出狀態
      }
    };

  const parseContent = (content) => {
    // Replace **text** with <strong>text</strong>
    return content
      .split(/\*\*(.*?)\*\*/g)
      .map((part, index) =>
        index % 2 === 1 ? <strong key={index}>{part}</strong> : part
      );
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <Title level={2}>與你聊聊</Title>
      <div
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          height: "400px",
          overflowY: "scroll",
        }}
      >
        <List
          dataSource={messages}
          renderItem={(msg, index) => (
            <List.Item key={index}>
              <strong>
                {" "}
                <FontAwesomeIcon
                  icon={msg.role === "user" ? faUser : faComments}
                  style={{ marginRight: "4px" }}
                />
                {msg.role === "user" ? "您提問" : "康乃馨寶寶"}:
              </strong>{" "}
              {parseContent(msg.content)}
            </List.Item>
          )}
        />
        {assistantTyping && (
          <List.Item>
            <strong>
              {" "}
              <FontAwesomeIcon
                icon={faComments}
                style={{ marginRight: "4px" }}
              />
              康乃馨寶寶:
            </strong>{" "}
            <strong>{assistantTyping}</strong>
          </List.Item>
        )}
        {loading && !assistantTyping && (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Spin tip="回應中..." />
          </div>
        )}
      </div>

      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", marginTop: "10px" }}
      >
        <Input
          value={userInput}
          disabled={assistantTyping} // 禁用輸入欄位
          onChange={handleInputChange}
          placeholder="請輸入您困擾的問題..."
          style={{
            flexGrow: 1,
            marginRight: "10px",
            backgroundColor: "#ffefd5",
          }}
        />
        <Button
          type="primary"
          htmlType="submit"
          disabled={!userInput.trim() || assistantTyping}
        >
          <FontAwesomeIcon
            icon={faCaretSquareUp}
            style={{ marginRight: "4px" }}
            color={assistantTyping ? "#666666" : "#E6E6E6"}
          />
          提問
        </Button>
        <Button
          onClick={handleInterruptTyping}
          disabled={!assistantTyping}
          style={{ marginLeft: "2px" }}
        >
          <FontAwesomeIcon
            icon={faStop}
            style={{ marginRight: "4px" }}
            color={assistantTyping ? "#4b0082" : "#E6E6E6"}
          />
          停止
        </Button>

        {/* Microphone Button */}
        <button
          type="button" // Prevents form submission
          onClick={handleToggleListening}
          style={{
            marginLeft: "10px",
            backgroundColor: isListening ? "red" : "transparent", // Change background color when listening
            border: "none",
            cursor: "pointer",
            width: "40px",
            height: "30px",
            borderRadius: "50%", // Optional for a circular button
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faMicrophone}
            color={isListening ? "#fff" : "#000"}
          />
        </button>
      </form>
    </div>
  );
};

export default connect((state) => ({ user: state.user }), {})(CreateCounseling);
